import { __decorate } from "tslib";
import { Component, Vue } from "@/types";
import "@/assets/scss/layouts/errorLayout.scss";
import { Button } from "@/ui-kit";
import { Auth } from "@/helpers/Auth";
let ErrorLayout = class ErrorLayout extends Vue {
    constructor() {
        super(...arguments);
        this.infoError = {
            errorString: "404",
            details: this.$l["notFound"],
        };
    }
    mounted() {
        if (this.$route.query?.status) {
            this.infoError = {
                ...this.infoError,
                errorString: this.$route.query.status,
                details: this.$l[this.$route.query.status === "403"
                    ? "accessDenied"
                    : "serviceUnavailable"],
            };
        }
    }
    async logout() {
        try {
            await Auth.logout();
        }
        catch (e) {
            console.log(e);
        }
    }
};
ErrorLayout = __decorate([
    Component({
        components: { Button },
    })
], ErrorLayout);
export default ErrorLayout;
